import styled from 'styled-components';

export const ToggleButton = styled.button<{ $isActive: boolean }>`
  background: ${({ $isActive }) =>
    $isActive ? 'rgba(80, 255, 120, 0.2)' : 'rgba(255, 80, 80, 0.2)'};
  border: 1px solid
    ${({ $isActive }) => ($isActive ? 'rgba(80, 255, 120, 0.5)' : 'rgba(255, 80, 80, 0.5)')};
  color: ${({ $isActive }) => ($isActive ? '#5f5' : '#ff5555')};
  font-family: 'Share Tech Mono', monospace;
  font-size: 11px;
  letter-spacing: 2px;
  padding: 0 16px;
  height: 32px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;

  &:hover {
    background: ${({ $isActive }) =>
      $isActive ? 'rgba(80, 255, 120, 0.3)' : 'rgba(255, 80, 80, 0.3)'};
  }

  @media (max-width: 768px) {
    font-size: 10px;
    padding: 0 12px;
    height: 24px;
  }
`;
